import { parseRegridSpendGuardStreetIdentity } from "./regrid-address-identity.ts";

// Legacy links remain recognized, but no longer authorize live provider dispatch.
export const KEENEY_EXISTING_DATA_POLICY = "keeney_existing_data_v1" as const;
export const KEENEY_VERIFICATION_POLICY = "keeney_regrid_verification_v1" as const;
export const KEENEY_VERIFICATION_ADDRESS = "2009 Keeney Street, Evanston, IL 60202" as const;
export const KEENEY_VERIFICATION_SUBJECT_SHA256 = "376f0e6cc77c2f58fc3c62f3c9b0bf2d16dd127ddb1677e250685056f2d92dab";
export const KEENEY_REGRID_RECORD_LIMITS = { regrid_subject_address: 20, regrid_subject_path: 1, regrid_comparable_radius: 75 } as const;
export type KeeneyVerificationOperation = keyof typeof KEENEY_REGRID_RECORD_LIMITS;
export function isPotentialKeeneyVerificationAddress(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const candidate = parseRegridSpendGuardStreetIdentity(value);
  const target = parseRegridSpendGuardStreetIdentity(KEENEY_VERIFICATION_ADDRESS);
  return candidate !== null && target !== null && candidate.houseNumber === target.houseNumber && candidate.streetKey === target.streetKey;
}
export function isKeeneyVerificationAddress(value: unknown): value is string {
  if (!isPotentialKeeneyVerificationAddress(value)) return false;
  const parts = value.split(",").map(part => part.normalize("NFKD").trim());
  return parts.length === 3 && !parts.some(part => /#|(?:^|[^a-z])(?:apt|apartment|unit|suite|ste)(?:[^a-z]|$)/i.test(part)) &&
    parts[1].toUpperCase() === "EVANSTON" && /^IL\s+60202(?:-\d{4})?$/i.test(parts[2]);
}
